import React from 'react'
import { View } from 'react-native'
import { Text } from '@src/components/base'
import { StyleService, useStyleSheet } from '@style/service.ts'

interface ProgramCardPrice {
  price?: number
  discount?: number
  total: number
}

export const ProgramCardPrice = ({ price, total, discount = 0 }: ProgramCardPrice) => {
  const styles = useStyleSheet(themedStyles)
  return (
    <View>
      <View style={styles.container}>
        {price !== undefined && discount > 0 && (
          <Text type="small" style={styles.secondaryPrice}>
            ${price}
          </Text>
        )}
        <Text type="large" bold>
          ${total}
        </Text>
      </View>
    </View>
  )
}

const themedStyles = StyleService.create({
  container: {
    flexDirection: 'row',
    gap: 4,
    alignItems: 'center',
  },
  secondaryPrice: {
    textDecorationLine: 'line-through',
    color: 'theme.text.secondary',
  },
})
